import { useCallback } from 'react'
import { OrderData, SetCompleteDataTy } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import { OrderLayoutTableFilter } from '../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/useOrderLayoutTableLogic/types'
import { TwinDictionary } from '../../globals/dictionary'
import { stringMatchWithSearch, numberMatchWithSearch } from '../../globals/search'

const processedMatchWithSearch = (searchValue: 'processed' | 'unprocessed', value: string | boolean) => {
    const itemIsProcessed = value === true || (value !== false && parseInt(value) !== 0)
    if (searchValue === 'processed' && !itemIsProcessed) {
        return false
    } else if (searchValue === 'unprocessed' && itemIsProcessed) {
        return false
    }
    return true
}
interface OrderRowRendererProps {
    setCompleteData: SetCompleteDataTy
}

const useInputTableFilterData = ({ setCompleteData }: OrderRowRendererProps) => {
    const parseTableData = useCallback((createFilters: (oldFilters: OrderLayoutTableFilter) => OrderLayoutTableFilter, completeData?: OrderData) => {
        setCompleteData((old) => {
            if (!old && !completeData) {
                return null
            }
            let myTableData = old
            const filters = myTableData?.filters ? createFilters(myTableData?.filters) : { generalSearchbar: '', order: {}, singleFieldsSearch: {} }
            if(completeData){
                myTableData = completeData
            }
            if(!myTableData){
                return null
            }
            let myfilteredTableData: any = []
            if (filters.generalSearchbar !== '' || Object.keys(filters.singleFieldsSearch)?.length) {
                myfilteredTableData = filterCompleteDataByFilters(myTableData?.tableData || [], filters)
                let processedTableLength = 0
                for (const element of myfilteredTableData) {
                    let myElement = myTableData?.tableData?.[myTableData?.dictPosTableData?.[element?.id]]
                    if (myElement.processed) {
                        processedTableLength++
                    }
                }
                return { ...myTableData, filteredTableData: myfilteredTableData, processedTableLength, filters } as any
            }
            let processedTableLength = 0
            for (const element of myTableData?.tableData) {
                if (element.processed) {
                    processedTableLength++
                }
            }
            return { ...myTableData, filteredTableData: null, processedTableLength, filters }
        })
    }, [setCompleteData])

    return {parseTableData}
}

const futureFieldsToCheck: TwinDictionary = {
    generalSearchbar: { fields: ['reference', 'code_bar', 'name', 'unique_number', 'notes'] },
    WorkSheetProductStatusId: { fields: ['WorkSheetProductStatusId', 'WorkSheetStatusParsedForSearch'], typeOfSearch: 'precise' },
    'Product.SpecificPriceRuleId': { fields: ['Product.SpecificPricesProduct.SpecificPriceRuleId'], typeOfSearch: 'precise' }, 
    selected: { fields: ['processed'], typeOfSearch: 'processed' }
}
const functionsByType: TwinDictionary = {
    general: stringMatchWithSearch,
    precise: numberMatchWithSearch,
    processed: processedMatchWithSearch
}

const filterCompleteDataByFilters = (tableData: { [fieldName: string]: any }[], filters: OrderLayoutTableFilter) => {
    const result: { [fieldName: string]: any }[] = []
    let lastParentVariantGroup: TwinDictionary | null = null
    let lastParentAddonGroup: TwinDictionary | null = null
    let variantIsSelected = false
    let variantIsPushed = false
    let addonIsSelected = false
    let addonIsPushed = false
    let dictTableData: TwinDictionary = {}
    let absoluteIndex = 0
    for (const product of tableData) {
        product.absoluteIndex = absoluteIndex
        absoluteIndex++
        if (!product.id) {
            continue
        }
        if (product.OrderVariantGroupId !== lastParentVariantGroup?.OrderVariantGroupId) {
            variantIsSelected = false
            variantIsPushed = false
            lastParentVariantGroup = null
        }
        if (product.OrderProductId !== lastParentAddonGroup?.id) {
            addonIsSelected = false
            addonIsPushed = false
            lastParentAddonGroup = null
        }
        dictTableData[product.id] = product
        let isVariantParent = product.FirstChildId && product.OrderVariantGroupId
        let isAddonParent = !isVariantParent && !product.OrderProductId
        if (isVariantParent) {
            variantIsSelected = false
            variantIsPushed = false
            lastParentVariantGroup = product
        } else if (isAddonParent) {
            addonIsSelected = false
            addonIsPushed = false
            lastParentAddonGroup = product
        }
        if (variantIsSelected || addonIsSelected) {
            result.push({ id: product.id })
        } else {
            const toSearch: [string, string][] = []
            if (filters.generalSearchbar !== '') {
                toSearch.push(['generalSearchbar', filters.generalSearchbar])
            }
            if (filters.singleFieldsSearch) {
                for (const key in filters.singleFieldsSearch) {
                    toSearch.push([key, filters.singleFieldsSearch[key]?.[0]])
                }
            }
            let mustAdd = true
            for (const toSearchItem of toSearch) {
                const [key, value] = toSearchItem
                const myField = futureFieldsToCheck[key]
                const myFields = myField.fields
                const typeOfSearch = myField.typeOfSearch || 'general'
                const myFunction = functionsByType[typeOfSearch]
                let foundField = false
                for (const field of myFields) {
                    if (myFunction(value, product[field])) {
                        foundField = true
                        break
                    }
                }
                if (!foundField) {
                    mustAdd = false
                }
            }
            if (mustAdd) {
                if (isVariantParent) {
                    variantIsSelected = true
                    variantIsPushed = true
                } else if (isAddonParent) {
                    if (!variantIsPushed && lastParentVariantGroup) {
                        result.push({ id: lastParentVariantGroup.id })
                        variantIsPushed = true
                    }
                    addonIsSelected = true
                    addonIsPushed = true
                } else {
                    if (!variantIsPushed && lastParentVariantGroup) {
                        result.push({ id: lastParentVariantGroup.id })
                        variantIsPushed = true
                    }
                    if (!addonIsPushed && lastParentAddonGroup) {
                        result.push({ id: lastParentAddonGroup.id })
                        addonIsPushed = true
                    }
                }
                result.push({ id: product.id })
            }
        }
    }
    return result
}

export default useInputTableFilterData